import { Head, useForm } from "@inertiajs/react";
import AuthLayout from "@/layouts/auth-layout";
import ProductForm from "@/pages/products/product-form";
import { buildProductFormData } from "@/pages/products/form-utils";
import { manage_products_path } from "@/routes";

function NewManageProduct({ product, errors }) {
  const { data, setData, post, processing } = useForm(buildProductFormData(product));

  const submit = (event) => {
    event.preventDefault();
    post(manage_products_path());
  };

  return (
    <>
      <Head title="Nyt globalt produkt" />

      <ProductForm
        data={data}
        setData={setData}
        errors={errors}
        processing={processing}
        onSubmit={submit}
        submitLabel="Opret produkt"
      />
    </>
  );
}

NewManageProduct.layout = (page) => (
  <AuthLayout
    header={{
      breadcrumbs: [
        { label: "Administration", href: manage_products_path() },
        { label: "Produkter", href: manage_products_path() },
        { label: "Nyt produkt" }
      ],
      title: "Opret globalt produkt",
      actions: [
        {
          href: manage_products_path(),
          label: "Tilbage",
          variant: "outline-secondary"
        }
      ]
    }}
  >
    {page}
  </AuthLayout>
);

export default NewManageProduct;
